import React from 'react';
import DefaultNav from './Default-nav/Default-nav';
import LimitedNav from './Limited-nav/Limited-nav';
import { useThemeContext } from '../../context/Theme';
import { Sidebar } from '../Sidebar/Sidebar';

export const MainContainer = ({
  view,
  variant,
  children,
}: {
  children: JSX.Element;
  view: 'limited' | 'default' | 'hidden';
  variant?: 'white' | 'black';
}) => {
  const { theme } = useThemeContext();

  return (
    <section
      className={`flex flex-col w-full h-full
        ${
          variant === 'black' || theme === 'DARK' ? 'bg-black-real' : 'bg-white'
        }
    `}
    >
      {view === 'limited' ? (
        <LimitedNav variant={variant} />
      ) : view === 'default' ? (
        <DefaultNav />
      ) : (
        <></>
      )}
      <article
        id="main"
        className={'py-5 flex flex-grow-1 h-auto w-full overflow-y-auto'}
      >
        <div
          id="container"
          className={
            'flex-grow-1 px-4 h-auto w-full w2col:w-w2col w3col:w-w3col w4col:w-w4col w5col:w-w5col mx-auto'
          }
        >
          {children}
        </div>
      </article>
      <Sidebar />
    </section>
  );
};
